export var IDENTIFIER_BUTTON_SELECT = 'button-select';
export var IDENTIFIER_BUTTON_SELECT_OPTIONS = 'button-select-options';
export var IDENTIFIER_BUTTON_SELECT_OPTION_ITEM = 'button-select-option-item';
export var IDENTIFIER_BUTTON_SELECT_OPTION_SHORTCUT = 'button-select-option-shortcut';
